<template>
<div class="footer-div " id="footer">
    <footer class="app-footer">
                <div class="custom-column ">
                    <div class="columns ">
                        <div class="column">
                            <div class="parts">
                                <h4 class="is-uppercase has-text-white footerTitle">{{texts.footerContactUs}}</h4>
                                <div class=" is-4">
                                    <a href="https://www.google.com/maps/place/46°21'56.8%22N+25°46'41.5%22E/@46.3657778,25.7771039,306m/data=!3m2!1e3!4b1!4m6!3m5!1s0x0:0x0!7e2!8m2!3d46.3657633!4d25.7781934" target="_blank">
                                        <div class="is-inline-flex">
                                            <img src="../assets/images/locationpointer.png">
                                            <p class="">{{texts.footerLocation}}, Romania</p>
                                        </div>
                                    </a>
                                </div>    
                                <div class="my-5 is-4">
                                    <a href="mailto:office@hebotrailers.com">
                                        <div class="is-inline-flex">
                                            <img src="../assets/images/mailicon.png">
                                            <p class="">office@hebotrailers.com</p>
                                        </div>
                                    </a>
                                </div>  
                                <div class=" is-4">    
                                    <a href="tel:+40786550430">
                                        <div class="is-inline-flex">
                                        
                                                <img src="../assets/images/phoneicon.png">
                                                <p class="">+40 786 550 430</p>
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="column">
                            <div class="parts">
                                <h4 class="is-uppercase has-text-white footerTitle"> {{ texts.footerFollowUs }}</h4>
                                <div class="socialMediaContainer">
                                    <div class=" is-4">
                                        <a href="https://www.facebook.com/hebotrailers" target="_blank">
                                            <div class="is-inline-flex">
                                                <img src="../assets/images/facebook.svg">
                                            </div>
                                        </a>
                                    </div> 
                                    <div class=" is-4">
                                        <a href="https://www.instagram.com/hebotrailers/?hl=en" target="_blank">
                                            <div class="is-inline-flex">
                                                <img src="../assets/images/insta.svg">
                                            </div>
                                        </a>
                                    </div>    
                                </div>
                            </div>
                            
                               
                           
                        </div>
                         
                    </div>
                </div>
    </footer>
     <div class="footer-bottom-line"> © {{actualYear}} HEBO TRAILERS, All rights reserved</div>
</div>    
    
</template>
<script>
export default {
    computed:{
        texts(){
            return this.$t('homePage')
        },
        actualYear(){
            return new Date().getFullYear();
        }
    }
}
</script>

<style lang="scss" scoped>
    
    .app-footer{    
        background-image: url('../assets/images/footer.jpg') ;
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
        position: relative;
        display: block;
        height: 269px;
    }
    .custom-column{
        margin: 0 auto;
        width: 600px;
        position: relative;
        top: 50%;
        transform: translateY(-50%);
        .column{
            text-align: left;
            padding-top: 30px;
            img{
                height: 1rem;
            }
        }
    }
    .custom-column p {
        font-size: .8rem;
        opacity: .7;
        color: #fff;
        padding: 0 8px;
    }
    
   
    .footer-bottom-line{
        color: #c0c0c0;
        background-color:rgb(1,16,21);
        bottom: 0;
        left: 0;
        right: 0;
        width: 100%;
        line-height: 4;
        font-size: .7rem;
        text-align: center;
    }

    .footerTitle {
        margin-bottom: 1.1rem;
    }
    .parts {
        width: fit-content;
        margin: 0 auto;
        div {
            margin: 8px 0;
        }
    }
    .socialMediaContainer {
        display: flex;
        flex-direction: row;
        div {
            margin: 0;
        }
        
        div:first-child {
            margin-right: 10px;
        }
    }

    .custom-column .column .socialMediaContainer img {
         height: 1.5rem;    
    }

     @media screen and (max-width: 768px) {
        .app-footer{  
            height: 370px;
        }
        .custom-column{
            width: 65%;
            .columns{
                display: block;
                .column{
                    width: 100%;
                    text-align: center;
                }
            }
        }
        .socialMediaContainer {
            justify-content: center;
        }
    }
</style>
